<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Factores Cleaver</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="cleaverFactorForm" (ngSubmit)="register()">
                    <div class="form-body">
                        <h3 class="card-title">Crear / actualizar factor</h3>
                        <hr>
                        <label class="control-label">Tipo</label>
                        <select formControlName="type" class="form-control custom-select">
                            <option selected disabled value="default">Seleccione una opción</option>
                            <option value="normal">Normal</option>
                            <option value="stress">Bajo Presión</option>
                            <option value="motivated">Motivado</option>
                        </select>

                        <h4 class="m-t-20">Estilo personal</h4>
                        <div class="row p-t-10">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Intervalo valor inferior</label>
                                    <input [ngModelOptions]="{standalone: true}" [(ngModel)]="personal.low" type="number"  class="form-control" placeholder="Intervalo valor inferior">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Intervalo valor superior</label>
                                    <input [ngModelOptions]="{standalone: true}" [(ngModel)]="personal.high" type="number"  class="form-control" placeholder="Intervalo valor superior">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Empuje d</label>
                                    <input [ngModelOptions]="{standalone: true}" [(ngModel)]="personal.d" type="text"  class="form-control" placeholder="Empuje d">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Persuasión i</label>
                                    <input [ngModelOptions]="{standalone: true}" [(ngModel)]="personal.i" type="text"  class="form-control" placeholder="Persuasión i">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Constancia s</label>
                                    <input [ngModelOptions]="{standalone: true}" [(ngModel)]="personal.s" type="text"  class="form-control" placeholder="Constancia s">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Apego c</label>
                                    <input [ngModelOptions]="{standalone: true}" [(ngModel)]="personal.c" type="text"  class="form-control" placeholder="Apego c">
                                </div>
                            </div>
                            <div *ngFor="let p of personalArray" class="row">
                                <span>|{{p.low}}-{{p.high}}| </span>
                            </div>
                            <div class="col-md-12">
                                <button type="button" class="btn waves-effect waves-light btn-rounded btn-success" (click)="addPersonal()">Agregar intervalo</button>
                            </div>

                        </div>
                        
                        <h4 >Conductas</h4>
                        
                        <div class="row p-t-20">
                            
                            <label class="control-label">Combinaciones</label>
                            <select [ngModelOptions]="{standalone: true}" [(ngModel)]="behavior.combination" class="form-control custom-select">
                                <option selected disabled value="default">Seleccione</option>
                                <option value="d/i">d/i</option>
                                <option value="d/s">d/s</option>
                                <option value="d/c">d/c</option>
                                <option value="i/d">i/d</option>
                                <option value="i/s">i/s</option>
                                <option value="i/c">i/c</option>
                                <option value="s/d">s/d</option>
                                <option value="s/i">s/i</option>
                                <option value="s/c">s/c</option>
                                <option value="c/d">c/d</option>
                                <option value="c/i">c/i</option>
                                <option value="c/s">c/s</option>
                                <option value="d=c+">d=c+</option>
                                <option value="d=c-">d=c-</option>

                            </select>
                            
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input [ngModelOptions]="{standalone: true}" [(ngModel)]="behavior.title" type="text"  class="form-control" placeholder="Titulo">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Descripción</label>
                                    <textarea [ngModelOptions]="{standalone: true}" [(ngModel)]="behavior.description" type="text"  class="form-control" placeholder="Descripción"></textarea>
                                </div>
                            </div>
                            <div *ngFor="let b of behaviorsArray" class="row">
                                <span>|{{b.combination}}| </span>
                            </div>
    
                            <div class="col-md-12">
                                <button type="button" class="btn waves-effect waves-light btn-rounded btn-success" (click)="addBehavior()">Agregar comportamiento</button>
                            </div>
                        </div>

                        <div class="row p-t-20">

                            <label class="control-label">Tag</label>
                            <select [ngModelOptions]="{standalone: true}" [(ngModel)]="maxMin.tag" class="form-control custom-select">
                                <option selected disabled value="default">Tag</option>
                                <option value="c+">c+</option>
                                <option value="c-">c-</option>
                                <option value="d+">d+</option>
                                <option value="d-">d-</option>
                                <option value="i+">i+</option>
                                <option value="i-">i-</option>
                                <option value="s+">s+</option>
                                <option value="s-">s-</option>

                            </select>
                            <div *ngIf="cleaverFactorForm.value.type!='motivated'" class="row m-t-10">
                                
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Título</label>
                                        <input [ngModelOptions]="{standalone: true}" [(ngModel)]="maxMin.title" type="text"  class="form-control" placeholder="Titulo">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Descripción</label>
                                        <textarea [ngModelOptions]="{standalone: true}" [(ngModel)]="maxMin.description" type="text"  class="form-control" placeholder="Descripción"></textarea>
    
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="cleaverFactorForm.value.type=='motivated'" class="row">
                                
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="control-label">Título</label>
                                        <input [ngModelOptions]="{standalone: true}" [(ngModel)]="maxMin.title" type="text"  class="form-control" placeholder="Titulo">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Desea</label>
                                        <textarea [ngModelOptions]="{standalone: true}" [(ngModel)]="maxMin.wish" type="text"  class="form-control" placeholder="Desea"></textarea>
    
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Necesita</label>
                                        <textarea [ngModelOptions]="{standalone: true}" [(ngModel)]="maxMin.require" type="text"  class="form-control" placeholder="Necesita"></textarea>
    
                                    </div>
                                </div>
                            </div>
                            <div *ngFor="let m of maxMinArray" class="row">
                                <span>|{{m.tag}}| </span>
                            </div>
                            <div class="col-md-12">
                                <button type="button" class="btn waves-effect waves-light btn-rounded btn-success" (click)="addMaxMin()">Agregar máximo/mínimo</button>
                            </div>
                        </div>

                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn btn-success m-r-20"> <i class="fa fa-check "></i> Guardar</button>
                        <button type="button" class="btn btn-danger" (click)="reset()"> <i class="fa fa-check"></i> Reinciar</button>
                    </div>
                    
                </form>
            </div>
        </div>
    </div>
</div>
